import { HttpGet } from "../utils/request";

export function marketHistoryData() {
     return HttpGet('/api/v3/mfmarkethistory')
}